import { render } from "./FCAFormIndividualPermissionComponent.vue?vue&type=template&id=09caf3d0&scoped=true"
import script from "./FCAFormIndividualPermissionComponent.vue?vue&type=script&lang=js"
export * from "./FCAFormIndividualPermissionComponent.vue?vue&type=script&lang=js"

import "./FCAFormIndividualPermissionComponent.vue?vue&type=style&index=0&id=09caf3d0&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09caf3d0"]])

export default __exports__